import parse_color from "parse-color";
export default class Transition {
    static number(options, fn) {
        const intervalMs = 16;
        const from = options.from || 0.0;
        const to = options.to || 1.0;
        const duration = options.duration || 1000;
        const step = (to - from) / (duration / intervalMs);
        let n = from;
        const timer = setInterval(() => {
            if (n >= to) {
                clearTimeout(timer);
                fn(to);
            }
            else {
                fn(n);
                n += step;
            }
        }, intervalMs);
    }
    static color(options, fn) {
        const toHex = (r, g, b) => `#${pad(r)}${pad(g)}${pad(b)}`;
        const pad = (n) => n < 0x10 ? `0${n.toString(16)}` : `${n.toString(16)}`;
        const from = parse_color(options.from).rgb;
        const to = parse_color(options.to).rgb;
        if (!from || !to) {
            return;
        }
        Transition.number({ from: 0.0, to: 1.0, duration: options.duration }, n => {
            const color = [0, 0, 0];
            for (let i = 0; i < 3; i++) {
                color[i] = Math.round(from[i] + (to[i] - from[i]) * n);
            }
            fn(toHex(color[0], color[1], color[2]));
        });
    }
}
